import { setListTab } from './tabList';

const healthXhash = encodeURI(window.location.hash);

if (healthXhash && document.querySelector(`.listTabs-block nav a[href="${healthXhash}"]`)) {
  const header = document.getElementById('header');
  const headerHeight = header.offsetHeight;
  const entry = document.querySelector(`.listTabs-block nav a[href="${healthXhash}"]`);

  if (entry) {
    setListTab(entry);
    window.scrollTo({
      top: entry.getBoundingClientRect().top - document.body.getBoundingClientRect().top - headerHeight - 60,
      behavior: 'smooth'
    });
  }
}
